import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initGsapStickyVerticalSections() {
    const wrappers = document.querySelectorAll('.sticky-vertical-sections-wrapper');

    if (!wrappers.length) return;

    wrappers.forEach(wrapper => {
        // Get all direct children (sections)
        // Note: We use wrapper.children initially, but we will be modifying the DOM.
        // So we convert to array first.
        const sections = gsap.utils.toArray(wrapper.children);
        
        sections.forEach((section, i) => {
            // Create a wrapper div for each section to hold the space
            const sectionWrap = document.createElement('div');
            sectionWrap.classList.add('sticky-section-wrap');
            sectionWrap.style.width = "100%"; // Ensure full width
            
            // Insert wrapper before section
            section.parentNode.insertBefore(sectionWrap, section);
            
            // Move section into wrapper
            sectionWrap.appendChild(section);
            
            // Set initial height
            sectionWrap.style.height = section.offsetHeight + "px";
            
            // Only pin if it's not the last section
            if (i < sections.length - 1) {
                ScrollTrigger.create({
                    trigger: sectionWrap,
                    start: "top top",
                    endTrigger: wrapper,
                    end: "bottom bottom", 
                    pin: section,
                    pinSpacing: false,
                    invalidateOnRefresh: true, // Ensure values are recalculated on refresh
                });
            }
        });
    });

    // Update heights on refresh (resize)
    ScrollTrigger.addEventListener("refreshInit", () => {
        const wraps = document.querySelectorAll('.sticky-section-wrap');
        wraps.forEach(wrap => {
            const section = wrap.firstElementChild;
            if (section) {
                // Reset height to auto to measure natural height
                wrap.style.height = 'auto';
                // Set new height
                wrap.style.height = section.offsetHeight + "px";
            }
        });
    });
}
